import { Injectable } from "@angular/core";
import { MessageService } from "primeng/api";
import { SeverityType } from "./severity-type.enum";

@Injectable()
export class MessagingService {

  constructor(
    private primeMessageService: MessageService
  ) { }

  showToast(message: string, severity = SeverityType.INFO) {
    this.primeMessageService.add({
      key: "app",
      severity: severity.toString(),
      detail: message});
  }

  showMessage(message: string, severity = SeverityType.INFO, key?: string) {
    this.primeMessageService.clear();
    this.primeMessageService.add({
      key: key || "appMessage",
      severity: severity.toString(),
      detail: message});
  }
}
